module.exports = __webpack_public_path__ + "img/tws4.d4b70430.png";